module.exports = __webpack_public_path__ + "static/img/haydar.4896a69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/haydar.jpg
// module id = BmRi
// module chunks = 1